import React, { useEffect, useState } from "react";
import v1 from "../../assets/projects/soilvfx/v1.mp4";
import Nav from "./Nav";
import ScrollTop from "../ScrollTop";
import Contact from "../Contact";
import Recent from "./Recent";
import Loader from "./Loader";

export const SoilVFX = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {" "}
          <Nav />
          <div className="figo">
            <div className="container">
              <div className="backImage soilvfxImgBef">
                <div className="overlay"></div>
                <h1>Soil VFX</h1>
              </div>
            </div>
            <h1>Story</h1>
            <div className="para">
              <p>
                As we welcome the New Year, an immersive VFX idea takes center
                stage, incorporating the very essence of soil into the facade—a
                symbolic tribute to growth and tradition.
              </p>
            </div>
            <div className="imge">
              <div className="f archiStyle">
                <video
                  src={v1 + "#t=1"}
                  controls="controls"
                  muted
                  alt=""
                ></video>
              </div>
            </div>
            <h1>Recent Projects</h1>
            <Recent />
          </div>
          <Contact />
          <ScrollTop />
        </>
      )}
    </>
  );
};
